import Phaser from 'phaser';
import { COLORS } from '../config';
import { formatNumber } from '../utils/formatNumber';

export class WallHPBar {
  private graphics: Phaser.GameObjects.Graphics;
  private label: Phaser.GameObjects.Text;
  private hpText: Phaser.GameObjects.Text;
  private x: number;
  private y: number;
  private width: number;
  private height: number;

  constructor(scene: Phaser.Scene, x: number, y: number, width: number, height: number) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.graphics = scene.add.graphics();
    this.label = scene.add.text(x + width / 2, y - 2, 'Wall HP', {
      fontSize: '10px',
      fontFamily: 'Arial, sans-serif',
      color: '#aaaaaa',
    }).setOrigin(0.5, 1);

    // HP text inside the bar
    this.hpText = scene.add.text(x + width / 2, y + height / 2, '', {
      fontSize: '11px',
      fontFamily: 'Arial, sans-serif',
      fontStyle: 'bold',
      color: '#ffffff',
      stroke: '#000000',
      strokeThickness: 2,
    }).setOrigin(0.5).setDepth(100);
  }

  update(current: number, max: number): void {
    this.graphics.clear();
    const pct = current / max;

    // Background
    this.graphics.fillStyle(COLORS.hpBarBg, 1);
    this.graphics.fillRoundedRect(this.x, this.y, this.width, this.height, 3);

    // Fill
    const color = pct > 0.5 ? COLORS.hpBarGreen : pct > 0.25 ? COLORS.hpBarYellow : COLORS.hpBarRed;
    this.graphics.fillStyle(color, 1);
    this.graphics.fillRoundedRect(this.x, this.y, this.width * pct, this.height, 3);

    // Border
    this.graphics.lineStyle(1, 0x666666, 1);
    this.graphics.strokeRoundedRect(this.x, this.y, this.width, this.height, 3);

    // Update HP text
    this.hpText.setText(`${formatNumber(Math.ceil(current))}/${formatNumber(max)}`);
  }
}
